import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';

export interface CancellationReason {
  id: number;
  displayText: string;
  isCommentRequired: number;
  sortOrder: number;
}

export interface CancellationReasonsResponse {
  cancelPlan: CancellationReason[];
  pausePlan: CancellationReason[];
}

export const getCancellationReasons = async (): Promise<CancellationReasonsResponse> => {
  const response = await api.get<CancellationReasonsResponse>(
    API_ENDPOINTS.CUSTOMERS.CANCELLATION_REASONS,
  );
  return response.data;
};
